export type Parametro = 'projeto' | 'pessoa' | 'periodo';

export interface Pergunta {
  id: string;
  texto: string;
  modelo?: string;
  parametro?: Parametro;
  acao?: 'enviar' | 'preencher';
}

export interface GrupoPerguntas { grupo: string; perguntas: Pergunta[] }

export const PERIODOS = [
  { rotulo: 'Esta semana', texto: 'nesta semana' },
  { rotulo: 'Semana passada', texto: 'na semana passada' },
  { rotulo: 'Este mês', texto: 'neste mês' },
  { rotulo: 'Mês passado', texto: 'no mês passado' },
  { rotulo: 'Este trimestre', texto: 'neste trimestre' },
];

const q = (id: string, modelo: string, parametro?: Parametro): Pergunta => ({
  id, texto: modelo, ...(parametro ? { modelo, parametro } : {}), acao: 'enviar',
});
const preencher = (id: string, texto: string): Pergunta => ({ id, texto, acao: 'preencher' });

// Espelha as regras de supabase/functions/assistente/access.ts.
export function catalogo(access: { isAdmin: boolean; canAccess: (section: string) => boolean }): GrupoPerguntas[] {
  const { isAdmin, canAccess } = access;
  const grupos: GrupoPerguntas[] = [];
  if (canAccess('time')) {
    grupos.push({ grupo: 'Suas horas', perguntas: [
      q('horas-periodo', 'Quanto lancei {periodo}?', 'periodo'),
      q('dias-sem-lancamento', 'Quais dias úteis ficaram sem lançamento {periodo}?', 'periodo'),
      q('ontem', 'O que lancei ontem?'),
      q('horas-projeto-mes', 'Quantas horas lancei no {projeto} este mês?', 'projeto'),
      q('faturavel-periodo', 'Quanto do que lancei {periodo} é faturável?', 'periodo'),
    ] });
    grupos.push({ grupo: 'Lançar horas', perguntas: [
      preencher('lancar-ontem-manha', 'Ontem das 9h às 12h no projeto '),
      preencher('lancar-hoje-tarde', 'Hoje das 14h às 17h no projeto '),
      preencher('lancar-ontem-2h', 'Ontem 2h no projeto '),
    ] });
  }
  if (canAccess('projects') || canAccess('activities-strategic')) {
    grupos.push({ grupo: 'Projetos e tarefas', perguntas: [
      q('projetos-risco', 'Quais projetos estão em risco?'),
      q('como-esta-projeto', 'Como está o {projeto}?', 'projeto'),
      q('atrasado-comigo', 'O que está atrasado comigo?'),
      q('atrasado-pessoa', 'O que está atrasado com {pessoa}?', 'pessoa'),
      q('tarefas-paradas', 'Quais tarefas estão paradas há mais de uma semana?'),
      q('resumo-semana', 'Resuma a semana do {projeto} para o cliente', 'projeto'),
    ] });
  }
  if (isAdmin) {
    grupos.push({ grupo: 'Equipe e receita', perguntas: [
      q('horas-pessoa', 'Horas por pessoa {periodo}', 'periodo'),
      q('horas-projeto', 'Horas por projeto {periodo}', 'periodo'),
      q('menos-30h', 'Quem lançou menos de 30h {periodo}?', 'periodo'),
      q('receita-cliente', 'Receita por cliente {periodo}', 'periodo'),
      q('receita-cargo', 'Receita por cargo {periodo}', 'periodo'),
    ] });
  }
  if (canAccess('price-simulator')) {
    grupos.push({ grupo: 'Propostas', perguntas: [
      q('estime-apto', 'Estime um apartamento de 120 m²'),
      q('estime-casa', 'Estime uma casa de 250 m²'),
      q('m2-apartamentos', 'Quanto cobramos por m² em apartamentos?'),
      q('parecidos-casa', 'Quais projetos parecidos com uma casa de 200 m² já fizemos?'),
    ] });
  }
  return grupos;
}

export function montar(p: Pergunta, valor: string): string {
  const modelo = p.modelo ?? p.texto;
  return p.parametro ? modelo.replace(`{${p.parametro}}`, () => valor) : modelo;
}

// Texto do botão: o parâmetro aparece como "…".
export function rotuloDe(p: Pergunta): string {
  return p.parametro ? montar(p, '…') : p.texto;
}
